export const cacheTags = {
    APPLICATIONS: 'Applications'
}